import React, { useMemo } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, styled, Typography, Dialog } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InexButton from "../../../InexButton";
import { useGetCommentsPlusQuery, useCreateCommentPlusMutation } from "../../../../store/api/odyssee";
import { useAuthToken } from "../../../../hooks/auth";
import CommentCard from "./CommentCard";
import { getInreesId } from "../../../../store/reducers/authSlice";
import { useSelector } from "react-redux";
import { useIsMobile } from "../../../../hooks/responsive";
import CommunityPng from "../../../../resources/images/png/COMMU.png";

import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import HardBreak from "@tiptap/extension-hard-break";
import { EditorContent, useEditor } from "@tiptap/react";

//create comment start

const extensions = [
	StarterKit.configure({
		hardBreak: false,
	}),
	Placeholder.configure({
		placeholder: "Votre commentaire ...",
	}),
	HardBreak.extend({
		addKeyboardShortcuts() {
			return {
				Enter: () => this.editor.commands.setHardBreak(),
			};
		},
	}),
];

const InputContainer = styled(Box)(() => {
	return {
		backgroundColor: "rgba(255,255,254,0.16)",
		borderRadius: 10,
		padding: 16,
	};
});

const EditorStyledContent = styled(EditorContent)(() => {
	return {
		color: "#FFFFFF",
		fontFamily: "Branding",
		fontWeight: 600,
		maxHeight: "50vh",
		overflowY: "auto",
	};
});

const CreateComment = ({ isOpen, handleModalClose, refetchUserQuestions, odysseeId }) => {
	const [createQuest] = useCreateCommentPlusMutation();
	const authToken = useAuthToken();

	const onContentUpdated = ({ editor }) => {
		// setDescription(editor.getHTML());
	};

	const editor = useEditor({
		extensions,
		content: "",
		onUpdate: onContentUpdated,
	});

	const dismiss = () => {
		handleModalClose();
		editor.commands.setContent("");
	};

	const uploadQuestion = () => {
		createQuest({ authToken, message: editor?.getHTML(), idodyssee: odysseeId }).then(() => {
			refetchUserQuestions();
		});
		dismiss();
	};

	return (
		<Dialog
			open={isOpen}
			onClose={handleModalClose}
			maxWidth={"md"}
			fullWidth={true}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			PaperProps={{
				style: {
					backgroundColor: "transparent",
					boxShadow: "0 0 30px 5px rgb(255, 255, 255, 0.6)",
					borderRadius: 10,
				},
			}}
			slotProps={{
				backdrop: {
					sx: {
						backgroundColor: "rgba(0, 0, 0, 0.9)",
					},
				},
			}}
		>
			<Box sx={{ backgroundColor: "#18122D", padding: 3 }}>
				<Box sx={{ display: "flex", width: "100%" }} mb={3}>
					<Typography
						color={"#ffffff"}
						fontFamily={"Branding Bold"}
						fontWeight={700}
						textAlign={"center"}
						fontSize={30}
					>
						Saisir votre commentaire
					</Typography>
				</Box>
				<InputContainer mb={3}>
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
						}}
						mb={2}
					>
						<Typography color={"#FFFFFE4D"}>Votre commentaire</Typography>
						<Typography color={"#FFFFFE4D"}>Requis</Typography>
					</Box>
					<EditorStyledContent style={{ width: "100%", minHeight: "150px" }} editor={editor} />
				</InputContainer>
				<Typography 
					variant="caption" 
					gutterBottom 
					sx={{ display: 'block', cursor: "pointer", textDecoration: 'underline' }} 
					color={"#FFFFFE4D"}
					onClick={()=> {
						window.open('https://www.inrees.com//conditions-generales-vente','_blank');
					}}
					>
					Règles de participation dans la communauté des odyssées
				</Typography>
				<Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
					<InexButton
						onClick={dismiss}
						variant={"text"}
						textWithGradient={false}
						textSx={{
							color: "#182B43",
						}}
						sx={{
							backgroundColor: "#C7C4DE",
							width: 100,
						}}
						text={"Annuler"}
					/>
					<InexButton
						onClick={uploadQuestion}
						variant={"text"}
						textWithGradient={false}
						textSx={{
							color: "#ffffff",
						}}
						sx={{
							backgroundColor: "#EF7D8F",
							width: 260,
						}}
						text={"Valider"}
					/>
				</Box>
			</Box>
		</Dialog>
	);
};

//create commentaire end

//block liste des commentaire
const Container = styled(Box)(() => {
	return {
		borderRadius: "20px",
		display: "flex",
	};
});

const InexAccordion = styled(Accordion)(() => {
	return {
		backgroundColor: "#FFFFFF0F",
		borderRadius: "20px",
		padding: "5px",
		borderTopLeftRadius: "20px !important",
		borderTopRightRadius: "20px !important",
		borderBottomRightRadius: "20px !important",
		borderBottomLeftRadius: "20px !important",
		width: "100%",
		"..MuiAccordion-root": {},
	};
});
const Commentaires = ({ odysseeId }) => {
	const [isExpanded, setExpanded] = React.useState(true);
	const [isModalOpen, setModelOpen] = React.useState(false);
	const authToken = useAuthToken();
	const inreesId = useSelector(getInreesId);

	const { data: userQuestions, refetch: refetchUserQuestions } = useGetCommentsPlusQuery(
		{ authToken, idodyssee: odysseeId, page: 0 },
		{ skip: !odysseeId || !authToken },
	);

	const createNewQuestion = (event) => {
		event?.stopPropagation();
		setModelOpen(true);
	};

	const filteredComments = React.useMemo(() => {
		return userQuestions?.questions.filter((comment) => {
			if (comment.state === 2) return true;
			if (comment.state === 0 || comment.state === 1) {
				return comment.idinexplore === parseInt(inreesId, 10);
			}
			return false;
		});
	}, [userQuestions, inreesId]);

	const isMobile = useIsMobile();

	return (
		<Container >
			<InexAccordion onChange={(event, expanded) => setExpanded(expanded)} defaultExpanded={true}>
				<AccordionSummary
					aria-controls="panel1-content"
					id="panel1-header"
					sx={{ width: "100%", margin: 0, maxWidth: "1OO%" }}
				>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							width: "100%",
						}}
					>
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								width: "100%",
							}}
						>
							<Box sx={{ display: "flex", gap: 2, alignItems: "center" }}> 
								<img
									alt={"odysee picture"}
									src={CommunityPng}
									style={{
										objectFit: "cover",
										width: 70,
										height: 70,
										borderRadius: "50%",
										overflow: "hidden",
									}}
								/>
								<Typography color={"#ffffff"} fontFamily={"Branding"} fontWeight={"bold"} fontSize={24}>
									Commentaires
								</Typography>
							</Box>
							<Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
								{!isMobile && (
									<InexButton
										onClick={createNewQuestion}
										variant={"text"}
										textWithGradient={false}
										textSx={{
											color: "#ffffff",
										}}
										sx={{
											backgroundColor: "#EF7D8F",
											width: 260,
										}}
										text={"Laisser un commentaire"}
									/>
								)}
								<ExpandMoreIcon
									sx={{
										color: "white",
										transform: `rotate(${isExpanded ? 180 : 0}deg)`,
										transition: "transform 0.2s ease",
									}}
								/>
							</Box>
						</Box>
						{isMobile && (
							<InexButton
								onClick={createNewQuestion}
								variant={"text"}
								textWithGradient={false}
								textSx={{
									color: "#ffffff",
								}}
								sx={{
									backgroundColor: "#EF7D8F",
									mt: 1,
									width: "100%",
								}}
								text={"Laisser un commentaire"}
							/>
						)}
					</Box>
				</AccordionSummary>
				<AccordionDetails>
					<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
						{filteredComments?.map((question) => (
							<CommentCard
								key={question?.id}
								firstName={question?.prenom}
								lastName={question?.nom}
								date={question?.creation}
								question={question?.message}
							/>
						))}
					</Box>
				</AccordionDetails>
			</InexAccordion>

			<CreateComment
				handleModalClose={() => setModelOpen(false)}
				isOpen={isModalOpen}
				refetchUserQuestions={refetchUserQuestions}
				odysseeId={odysseeId}
			/>
		</Container>
	);
};


export default Commentaires;
